import React from "react";
import moment from "moment";
import {FieldProps} from "../List";

export default ({value}: FieldProps) => {
    return moment(value).format("YYYY-MM-DD HH:mm:ss")
}